
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'detailsContainer': {'padding': `0px 20px`,},'addressDetails': {'padding': `18px 0px 18px 0px`,},'largerBoldText': {'fontWeight': `bold`,'fontWeight': `bold`,'fontSize': `14px`,'color': `#ffffff`,'marginBottom': `16px`,'fontSize': `18px`,'fontFamily': `'Lemon-Regular', sans-serif`,},'boldText': {'fontWeight': `bold`,'fontSize': `14px`,'color': `#ffffff`,},'dateAndTime': {'fontWeight': `bold`,'fontSize': `14px`,'color': `#ffffff`,'fontWeight': `bold`,},'timeDetails': {'marginBottom': `16px`,},
        
      };
    };
  